import { render, staticRenderFns } from "./WhySectionList.vue?vue&type=template&id=3a113b5d&scoped=true&"
import script from "./WhySectionList.vue?vue&type=script&lang=js&"
export * from "./WhySectionList.vue?vue&type=script&lang=js&"
import style0 from "./WhySectionList.vue?vue&type=style&index=0&id=3a113b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a113b5d",
  null
  
)

export default component.exports